export default __webpack_public_path__ + "static/media/IMG_1928-85.6797c66d.jpg";